import React from "react";
import { LifeBuoy, ExternalLink } from "lucide-react";

const SupportHubvex: React.FC = () => {
  const SUPPORT_URL = "https://auth.hubvex.com/auth/login/";
  return (
    <div className="mt-auto pt-6 border-t border-white/10">
      <div
        className="relative rounded-2xl p-3 backdrop-blur-sm transition-all duration-300 hover:shadow-[0_8px_20px_-6px_rgba(0,0,0,0.4),0_0_0_1px_rgba(22,241,158,0.2)] overflow-hidden"
        style={{
          backgroundImage: `url('/assets/images/bgillustra/fondvert.jpeg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Overlay sombre pour la lisibilité */}
        <div className="absolute inset-0 bg-black/40 rounded-2xl" />

        {/* Contenu relatif */}
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo/logofavicon_hubvex.png"
              alt="Hubvex"
              className="h-10 w-10 rounded-lg object-contain shadow-md bg-white p-1"
            />
            <div className="flex-1">
              <p className="text-xs font-medium text-gray-200">Support technique</p>
              <p className="text-sm font-semibold text-white">Hubvex</p>
            </div>
          </div>
          <div className="mt-3 flex gap-2">
            <a
              href={SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 flex items-center justify-center gap-1 rounded-lg bg-primary/30 py-1.5 text-xs font-medium text-white transition-all hover:bg-primary/50 hover:shadow-[0_2px_6px_rgba(22,241,158,0.4)]"
            >
              <LifeBuoy size={14} />
              Aide
            </a>

            <a
              href={SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 flex items-center justify-center gap-1 rounded-lg bg-white/20 py-1.5 text-xs font-medium text-white transition-all hover:bg-white/30 hover:shadow-[0_2px_6px_rgba(255,255,255,0.2)]"
            >
              <ExternalLink size={14} />
              Contacter
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportHubvex;